import React from 'react';
import styles from '../../../../../stylesheet/css/header-builder/icons/exit.css';

/**
 * Get parameter URL.
 * @param  {string} name Parameter name from URL.
 * @return {string}      The value of parameter name. Default is null.
 *
 * @todo - Find React way to get URL parameters.
 */
function getParamURL( name ) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '/wp-admin/' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

const Exit = (props, returnURL) => (
    <a href={getParamURL( 'return' )} className={styles.exit}>
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             width="28px" height="23px" viewBox="0 0 28 23" xmlSpace="preserve" fill="#d8d5d4">
            <g>
                <g>
                    <path d="M1,10.8C1,5.4,5.3,1,10.6,1c5.3,0,9.6,4.4,9.6,9.8c0,1.7-0.4,3.3-1.2,4.7c0.4-0.1,0.9-0.2,1.3-0.4
                        c0.6-1.3,0.9-2.8,0.9-4.3c0-6-4.7-10.8-10.6-10.8C4.7,0,0,4.9,0,10.8s4.7,10.8,10.6,10.8c0.2,0,0.3,0,0.5,0l-2.3-1.2
                        C4.3,19.6,1,15.6,1,10.8z M27.2,11.4l-1.2,1.5c-0.5,0.5-0.9,0.9-1.4,1.4c-1,0.8-2,1.5-3.1,2.1c-1.1,0.5-2.2,0.8-3.4,0.9
                        c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.5,0v-3.1l-8.6,4.4L17,23v-2.6c0.5-0.1,1.1-0.1,1.6-0.3c1.5-0.4,2.8-1,4-1.8
                        c1.2-0.8,2.2-1.8,3.1-2.9c0.5-0.5,0.8-1.1,1.2-1.7l1-1.8L27.2,11.4z M16.4,12.8c0.2-0.1,0.4-0.2,0.7-0.2c0.3,0,0.6,0.1,0.8,0.2
                        c0.2,0.1,0.3,0.3,0.4,0.4c0.2-0.8,0.4-1.6,0.4-2.4c0-1.4-0.4-2.8-1-4c0,0.3,0.1,0.5,0.1,0.8c0,0.8-0.2,1.8-0.6,3L16.4,12.8z
                         M2.5,10.8c0,3.2,1.8,6,4.4,7.4c0,0,0-0.1,0-0.1L3.2,7.5C2.8,8.5,2.5,9.6,2.5,10.8z M15.9,4.7c0,0,0.1,0,0.1,0
                        c-1.4-1.3-3.3-2.2-5.4-2.2c-2.8,0-5.3,1.5-6.7,3.7c0.2,0,0.4,0,0.5,0c0.8,0,2.1-0.1,2.1-0.1c0.4,0,0.5,0.6,0.1,0.7
                        c0,0-0.4,0.1-0.9,0.1l2.9,8.9l1.8-5.4L9.1,7c-0.4,0-0.8-0.1-0.8-0.1c-0.4,0-0.4-0.7,0.1-0.7c0,0,1.3,0.1,2.1,0.1
                        c0.8,0,2.1-0.1,2.1-0.1c0.4,0,0.5,0.6,0.1,0.7c0,0-0.4,0.1-0.9,0.1l2.3,7l1.3-0.7l0.1-0.2c0.3-1.1,0.6-2,0.6-2.7
                        c0-1-0.4-1.7-0.7-2.3c-0.4-0.7-0.8-1.3-0.8-1.9C14.5,5.4,15.1,4.7,15.9,4.7z M9,16.5l2.9-1.5l-1.2-3.5L9,16.5z"/>
                </g>
            </g>
        </svg>
    </a>
);

export default Exit;



// WEBPACK FOOTER //
// ./app/header-builder/components/icons/Exit.js